module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "uk-width uk-margin-remove uk-padding-remove"
  }, [_c('h3', {
    staticClass: "uk-flex-inline"
  }, [_vm._v("Status wizyty")]), _vm._v(" "), (_vm.status === 'zarejestrowana') ? _c('span', {
    staticClass: "uk-label uk-label-primary",
    staticStyle: {
      "margin-top": "-5px",
      "margin-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.status))]) : _c('span', {
    staticClass: "uk-label uk-label-warning",
    staticStyle: {
      "margin-top": "-5px",
      "margin-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.status))]), _vm._v(" "), (_vm.status === 'zarejestrowana' && _vm.isBeforeVisit) ? _c('div', {
    staticClass: "float-right"
  }, [(_vm.platnoscOnline === 'enable') ? _c('a', {
    attrs: {
      "href": _vm.platnoscOnlineLink,
      "target": "_blank"
    }
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small"
  }, [_vm._v("Zapłać online")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-default uk-button-small",
    attrs: {
      "uk-toggle": "target: #change-visit-date-modal"
    }
  }, [_vm._v("Zmień termin wizyty")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-button-small",
    attrs: {
      "uk-toggle": "target: #cancel-visit-modal"
    }
  }, [_vm._v("Odwołaj wizytę")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-wrap"
  }, [_c('div', {
    staticClass: "uk-width-1-2@m",
    attrs: {
      "id": "visit-notifications"
    }
  }, [_c('h4', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("Szczegóły wizyty")]), _vm._v(" "), _c('strong', [_vm._v("Powód wizyty:")]), _vm._v(" " + _vm._s(_vm.reason)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Lekarz:")]), _vm._v(" " + _vm._s(_vm.doctor)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Termin:")]), _vm._v(" " + _vm._s(_vm._f("formatDate")(_vm.data))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Godzina:")]), _vm._v(" " + _vm._s(_vm._f("formatTime")(_vm.data))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Lokalizacja wizyty:")]), _vm._v(" " + _vm._s(_vm.adres1) + ", " + _vm._s(_vm.adres2)), _c('br'), _vm._v(" "), _c('strong', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.information !== ''),
      expression: "information !== ''"
    }]
  }, [_vm._v("Jak się przygotować do wizyty:")]), _vm._v(" " + _vm._s(_vm.information)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Rodzaj wizyty:")]), _vm._v(" " + _vm._s(_vm.type === 'PLN' ? 'komercyjna' : (_vm.type === 'NFZ' ? 'refundowana NFZ' : 'bezpłatna'))), _c('br'), _vm._v(" "), (_vm.type === 'PLN') ? _c('span', [_c('strong', [_vm._v("Cena:")]), _vm._v(" " + _vm._s(_vm.cena))]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.position === '-1') ? _c('strong') : _c('strong', [_vm._v("Numer w kolejce:")]), _vm._v(" "), (_vm.position === '-1') ? _c('span') : _c('span', [_vm._v(_vm._s(_vm.position))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr', {
    staticClass: "uk-wdith"
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-2@m uk-overflow-auto",
    attrs: {
      "id": "visit-documents"
    }
  }, [_c('h4', [_vm._v("Dokumentacja medyczna do pobrania")]), _vm._v(" "), (_vm.documentsLoading) ? _c('div', [_c('div', {
    attrs: {
      "uk-spinner": ""
    }
  })]) : _c('div', [(_vm.documents && _vm.documents !== '') ? _c('div', [_c('table', {
    staticClass: "uk-table uk-table-middle uk-table-divider uk-table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.documents), function(document) {
    return _c('tr', [_c('td', [(document.IDportal === 1 || document.IDportal !== 4 && document.IDDokumenty !== 0) ? _c('span', {
      staticClass: "uk-label uk-label-success",
      staticStyle: {
        "background-color": "#2ea278"
      }
    }, [_vm._v("Gotowy do pobrania")]) : (document.IDportal === 4 && document.IDDokumenty !== 0) ? _c('span', {
      staticClass: "uk-label uk-label-primary"
    }, [_vm._v("Odbiór osobisty")]) : _vm._e(), _vm._v(" "), (document.IDportal === 2 && document.IDDokumenty === 0) ? _c('span', {
      staticClass: "uk-label uk-label-warning"
    }, [_vm._v("Wymaga zamówienia")]) : (document.IDportal === 3 && document.IDDokumenty === 0) ? _c('span', {
      staticClass: "uk-label uk-label-warning"
    }, [_vm._v("Wymaga zamówienia")]) : (document.IDportal === 4 && document.IDDokumenty === 0) ? _c('span', {
      staticClass: "uk-label uk-label-warning"
    }, [_vm._v("Wymaga zamówienia")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(document.fileName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right",
        "padding-right": "0px"
      }
    }, [(document.IDportal === 1 || document.IDportal !== 4 && document.IDDokumenty !== 0) ? _c('button', {
      staticClass: "uk-button uk-button-primary uk-button-small pull-right",
      on: {
        "click": function($event) {
          return _vm.getDoc(document.IDDokumenty)
        }
      }
    }, [_vm._v("Pobierz")]) : (document.IDportal === 4 && document.IDDokumenty !== 0) ? _c('button', {
      staticClass: "uk-button uk-button-primary uk-button-small pull-right",
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("Pobierz")]) : _vm._e(), _vm._v(" "), (document.IDportal === 2 && document.IDDokumenty === 0 || document.IDportal === 3 && document.IDDokumenty === 0 || document.IDportal === 4 && document.IDDokumenty === 0) ? _c('button', {
      staticClass: "uk-button uk-button-default uk-button-small pull-right",
      on: {
        "click": function($event) {
          return _vm.orderDoc(document.IDKorSzablon)
        }
      }
    }, [_vm._v("Zamów")]) : _vm._e()])])
  }), 0)])]) : _c('div', [_vm._v("\n          Brak dokumentów do pobrania\n        ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ankietaPar === 1),
      expression: "ankietaPar === 1"
    }],
    staticClass: "uk-width-2-2@m uk-margin-top",
    attrs: {
      "id": "visit-questionnaire"
    }
  }, [_c('h4', {
    staticStyle: {
      "margin-top": "0px !important"
    }
  }, [_vm._v("Ankieta przed wizytą")]), _vm._v(" "), (_vm.ankietaPar !== 1) ? _c('strong', [_vm._v(_vm._s(_vm.ankietaTxt))]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "visit-questionnaire-box"
    }
  }, [(_vm.ankietaPar === 1) ? _c('button', {
    staticClass: "uk-button uk-button-primary",
    on: {
      "click": _vm.fillQuestionnaire
    }
  }, [_vm._v("Wypełnij ankiete")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "change-visit-date-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Zmiana terminu wizyty")]), _vm._v(" "), _c('p', [_vm._v("Czy na pewno chcesz zmienić termin wizyty? Dotychczasowy termin wizyty zostanie anulowany.")]), _vm._v(" "), _c('p', {
    staticClass: "uk-text-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Nie")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-modal-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.changeVisit
    }
  }, [_vm._v("Tak")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cancel-visit-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Odwołanie wizyty")]), _vm._v(" "), _c('p', [_vm._v("Czy na pewno chcesz odwołać tą wizytę?")]), _vm._v(" "), _c('p', {
    staticClass: "uk-text-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Nie")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-modal-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelVisit
    }
  }, [_vm._v("Tak")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "exit-without-save-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Wyjście z wizyty bez zapisu")]), _vm._v(" "), _c('p', [_vm._v("Czy na pewno chcesz wyjść z widoku wizyty bez wcześniejczego zapisania zmian?")]), _vm._v(" "), _c('p', {
    staticClass: "uk-text-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-modal-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.exitVisit(true)
      }
    }
  }, [_vm._v("Zapisz zmiany i wyjdź")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-modal-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exitVisit
    }
  }, [_vm._v("Tak")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "uk-width-small"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Opis")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-577c9ead","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Visit.vue
// module id = 243
// module chunks = 1